import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE_ORIGIN =
  "https://posherofficial.com";

const indexableRoutes = [
  /^\/$/,
  /^\/new\/?$/,
  /^\/co-ords\/?$/,
  /^\/dresses\/?$/,
  /^\/product\/?$/,
  /^\/product\/[^/]+\/?$/,
  /^\/consultation\/?$/,
  /^\/about\/?$/,
  /^\/conditions\/?$/,
  /^\/faq\/?$/,
  /^\/refund\/?$/,
  /^\/bridal\/?$/,
];

function SeoManager() {
  const { pathname } = useLocation();

  useEffect(() => {
    const normalizedPath =
      pathname === "/"
        ? "/"
        : pathname.replace(/\/+$/, "");

    const canonicalUrl =
      `${SITE_ORIGIN}${normalizedPath}`;

    let canonical = document.querySelector(
      'link[rel="canonical"]'
    );

    if (!canonical) {
      canonical =
        document.createElement("link");

      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }

    canonical.href = canonicalUrl;

    const isIndexable =
      indexableRoutes.some((pattern) =>
        pattern.test(pathname)
      );

    let robots = document.querySelector(
      'meta[name="robots"]'
    );

    if (!robots) {
      robots =
        document.createElement("meta");

      robots.name = "robots";
      document.head.appendChild(robots);
    }

    robots.content = isIndexable
      ? "index, follow"
      : "noindex, nofollow";
  }, [pathname]);

  return null;
}

export default SeoManager;